export default __webpack_public_path__ + "static/media/cardCourseInfo.47b1d472.png";